import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getClassesAction = createAsyncThunk(
  'class/getClassesAction',
  async (
    { query, currentPage, pageSize, sortBy, orderBy, isAdminMode = true },
    { rejectWithValue }
  ) => {
    try {
      let apiRoute = `${isAdminMode ? '/admin/classes' : '/classes'}?currentPage=${currentPage}&pageSize=${pageSize}`;
      if (query) apiRoute += `&query=${query}`;
      if (sortBy) apiRoute += `&sortBy=${sortBy}`;
      if (orderBy) apiRoute += `&orderBy=${orderBy}`;

      const response = await axios.get(apiRoute);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const getClassAction = createAsyncThunk(
  'class/getClassAction',
  async ({ id, isAdminMode = true }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${isAdminMode ? '/admin/classes' : '/classes'}/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const getClassProgressionsAction = createAsyncThunk(
  'class/getClassProgressionsAction',
  async ({ id, isAdminMode = true }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${isAdminMode ? '/admin/classes' : '/classes'}/${id}/progressions`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const getClassRecordsAction = createAsyncThunk(
  'class/getClassRecordsAction',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/admin/classes/${id}/records`);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const createClassAction = createAsyncThunk(
  'class/createClassAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/classes', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const addClassUsersAction = createAsyncThunk(
  'class/addClassUsersAction',
  async ({ classId, emails, isSendNotif }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/admin/classes/${classId}/users`,
        { emails, isSendNotif },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const updateClassAction = createAsyncThunk(
  'class/updateClassAction',
  async ({ id, classData }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/admin/classes/${id}`, classData);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const deleteClassAction = createAsyncThunk(
  'class/deleteClassAction',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`/admin/classes/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

export const deleteClassUserAction = createAsyncThunk(
  'class/deleteClassUserAction',
  async ({ classId, userId }, { rejectWithValue }) => {
    try {
      await axios.delete(`/admin/classes/${classId}/users/${userId}`);
      return userId;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
